import React from "react";


export const about_us = {
    AboutUsHeader : "/Images/JPG/Webuildd-About-Us-Header.jpg" ,
    AboutQualityIcon :  "/Images/About_US/icon/About-qualiyty-icon.svg" , 
    AboutTransparencyIcon :  "/Images/About_US/icon/About-Transparency-icon.svg" , 
    AboutCostIcon : "/Images/About_US/icon/About-Cost-icon.svg" , 
    AboutQuality :  "/Images/JPG/Webuildd-Quality.jpg" , 
    AboutTransparency : "/Images/JPG/Webuildd-Transparency.jpg" , 
    AboutCost : "/Images/JPG/Webuildd-Cost.jpg" , 
    AboutHowItWorks : "/Images/About_US/About-Howitworks.jpg" , 
    FounderCard :"/Images/About_US/Founder-Card.jpg" , 
    FounderCard1 :"/Images/About_US/Founder-Card-1.jpg" ,
    FounderCard2 : "/Images/About_US/Founder-Card-2.jpg" , 
    FounderCard3 : "/Images/About_US/Founder-Card-3.jpg" , 
    Experience : "/Images/JPG/Webuildd-Experience.jpg",
    Warranty : "/Images/JPG/Webuildd-Warranty.jpg",
    Completion : "/Images/JPG/Webuildd-Completion.jpg",
    SOPC : "/Images/JPG/Webuildd-SPOC.jpg",
    
}

export const Blogs = {
        BlogHeader:  "/Images/JPG/Webuildd-Blog-header.jpg" , 
}

export const BlogCards = [
    {blogThumbnail: "/Images/Blogs/Gallery/Blog-Card-1.jpg" , 
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    text3: "Read More",
    DesktopView: "",
    plusProps:"https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",  
    className:""  
    },
            
    {blogThumbnail: "/Images/Blogs/Gallery/Blog-Card-2.jpg" , 
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    text3: "Read More",
    DesktopView: "",
    plusProps: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
    className:"blog-card-1"    
    },

    {blogThumbnail: "/Images/Blogs/Gallery/Blog-Card-3.jpg" , 
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    text3: "Read More",
    DesktopView: "",
    plusProps:"https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",     
    className:"blog-card-1"     
    },

    {blogThumbnail: "/Images/Blogs/Gallery/Blog-Card-4.jpg" , 
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "",
    DesktopView: "",
    text3: "Read More",
    plusProps:"https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
    },
    {blogThumbnail: "/Images/Blogs/Gallery/Blog-Card-5.jpg" , 
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "blog-card-1",
    DesktopView: "",
    text3: "Read More",
    plusProps: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",  
    },
    {blogThumbnail: "/Images/Blogs/Gallery/Blog-Card-6.jpg" , 
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "blog-card-1",
    DesktopView: "",
    text3: "Read More",
    plusProps: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
    },
    {blogThumbnail: "/Images/Blogs/Gallery/Blog-Card-7.jpg" , 
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "",
    DesktopView: "",
    text3: "Read More",
    plusProps:"https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",  
    },
    {blogThumbnail: "/Images/Blogs/Gallery/Blog-Card-8.jpg" , 
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "blog-card-1",
    DesktopView: "",
    text3: "Read More",
    plusProps: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
    },
    {blogThumbnail: "/Images/Blogs/Gallery/Blog-Card-9.jpg" , 
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "blog-card-1 desktop-only",
    DesktopView: "",
    text3: "Read More",
    plusProps: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",    
    },    
    
]


export const blog_detail = {
    BlogDetailHeader: "/Images/Blogs_detail/Blog-Detail-Header.jpg" , 
    BlogDetailWriter: "/Images/Blogs_detail/Blog-Detail-Writer.png" , 
    BlogDetailCard1: "/Images/Blogs_detail/Gallery/Blogdetail-Card-1.jpg" , 
    BlogDetailCard2: "/Images/Blogs_detail/Gallery/Blogdetail-Card-2.jpg" ,
}
    

export const contact = {
    ContactHeader:"/Images/JPG/Webuildd-Contact-Header.jpg" , 
}
   

export const faq_s = {
    FAQsHeader : "/Images/JPG/Webuildd-FAQs-Header.jpg" ,
}
     

export const footer = {
        Facebook: "/Images/Footer/Facebook-icon.svg" , 
        Instagram: "/Images/Footer/Instagram-icon.svg" , 
        Mail:"/Images/Footer/Mail-icon.svg" , 
        Phone: "/Images/Footer/Phone-icon.svg" ,
        Twitter: "/Images/Footer/Twitter-icon.svg" , 
        Webuildd:"/Images/Footer/Webuildd-icon.svg" , 
        Map:'./Images/Footer/Map-icon.svg'
}
        

export const get_a_quote = {
    GetQuote : "/Images/Get_a_quote/GetQuote.jpg" , 
}   
  
export const header = {
    WebuilddHeaderIcon: "/Images/Header/Webuildd-Header-icon.svg" , 
}
   


export const home_page = {
        CostEstimatorBG: "/Images/Home_Page/Cost-Estimator-BG.jpg" ,
        Plan: "/Images/Home_Page/Img/Icons/plan.svg" , 
        BluePrint: "/Images/Home_Page/Img/Icons/blueprint.svg" , 
        Building: "/Images/Home_Page/Img/Icons/building.svg" , 
        Ellipse1: "/Images/Home_Page/Img/Testimonial/Ellipse-1.png" , 
        Ellipse2:"/Images/Home_Page/Img/Testimonial/Ellipse-2.png" , 
        HomePageCarousel1: "/Images/Home_Page/Img/Carousel/Carousel-01.jpg" ,
        HomePageCarousel2: "/Images/Home_Page/Img/Carousel/Carousel-02.jpg" , 
        HomePageCarousel3: "/Images/Home_Page/Img/Carousel/Carousel-03.jpg" , 
        HomePageCarousel4: "/Images/Home_Page/Img/Carousel/Carousel-04.jpg" ,  
        WhyWebuild1: "/Images/JPG/Why-Webuild-Difference.jpg" , 
        WhyWebuild2: "/Images/JPG/Why-Webuild-Maximum-Value.jpg" , 
        WhyWebuild3:"/Images/JPG/Why-Webuild-Customer-Value.jpg" ,
        
}

export const home_page_cards = [
    {HomePageCard: "/Images/Home_Page/Img/Projects/Homepage-Card-1.png"},
    {HomePageCard: "/Images/Home_Page/Img/Projects/Homepage-Card-2.png"},
    {HomePageCard:"/Images/Home_Page/Img/Projects/Homepage-Card-3.png" }

]

export const ProjectCards =  [
    {   id:1,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_HRBR_Card.jpg" , 
        className: "landing-page-project-card",
        text1: "1BHK / 2BHK Duplex Residential - 30’x45’",
        surname: "Mr. Srinivas - HRBR, Bangalore.",
    },
    {   id:2,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_Manju_Card.jpg" , 
        className: "landing-page-project-card",
        text1: "1BHK / 4BHK Triplex Residential – 30’x50’",
        surname: "Dr. Manjunath & Dr. Gayathri P – Ullal, Bangalore",
    },
    {   id:3,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_Vijay_Card.jpg" , 
        className: "landing-page-project-card",
        text1: "1BHK / 3BHK Duplex Residential - 33’x24’",
        surname: "Mr. Vijay Venketeshwaran - Potti Gardens, Jalahalli, Bangalore",    
    },
    {   id:4,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_Shomith_Card.jpg" , 
        className: "landing-page-project-card",
        text1: "4BHK Duplex Residential - 30’x50’",
        surname: "Mr. Shomith - Dodabelle, Kengeri(Blue Jay Properties), Bangalore",    
    },
    {   id:5,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_Interiors_Card.jpg" , 
        className: "landing-page-project-card",
        text1: "1BHK / 4BHK Triplex Residential – 30’x50’",
        surname: "Dr. Manjunath & Dr. Gayathri P – Ullal, Bangalore",
    },
    // {   id:5,
    //     rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-5.png" , 
    //     className: "landing-page-project-card",
    //     text1: "Project Name",
    //     surname: "Small description about the project",
    // },
    // {   id:6,
    //     rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-6.png" , 
    //     className: "landing-page-project-card",
    //     text1: "Project Name",
    //     surname: "Small description about the project",
    // },
    // {   id:7,
    //     rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-7.png" , 
    //     className: "landing-page-project-card",
    //     text1: "Project Name",
    //     surname: "Small description about the project",
    // },
    // {   id:8,
    //     rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-8.png" , 
    //     className: "landing-page-project-card",
    //     text1: "Project Name",
    //     surname: "Small description about the project",
    // },
    // {   id:9,
    //     rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-9.png" , 
    //     className: "landing-page-project-card desktop-only",
    //     text1: "Project Name",
    //     surname: "Small description about the project",
    // }
] 

export const Residential = [
           
    {   id:1,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_HRBR_Card.jpg" ,
        className: "landing-page-project-card",
        text1: "1BHK / 2BHK Duplex Residential - 30’x45’",
        surname: "Mr. Srinivas - HRBR, Bangalore.",
    },
    {   id:2,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_Manju_Card.jpg" , 
        className: "landing-page-project-card",
        text1: "1BHK / 4BHK Triplex Residential – 30’x50’",
        surname: "Dr. Manjunath & Dr. Gayathri P – Ullal, Bangalore",
    },
    {   id:3,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_Vijay_Card.jpg" , 
        className: "landing-page-project-card",
        text1: "1BHK / 3BHK Duplex Residential - 33’x24’",
        surname: "Mr. Vijay Venketeshwaran - Potti Gardens, Jalahalli, Bangalore",    
    },
    {   id:4,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_Shomith_Card.jpg" , 
        className: "landing-page-project-card",
        text1: "4BHK Duplex Residential - 30’x50’",
        surname: "Mr. Shomith - Dodabelle, Kengeri(Blue Jay Properties), Bangalore",    
    }
]
export const Commercial = [
       
    {   id:1,
        rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-4.png" , 
        className: "landing-page-project-card",
        text1: "Project Name",
        surname: "Small description about the project",
    },
    // {   id:2,
    //     rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-2.png" , 
    //     className: "landing-page-project-card",
    //     text1: "Project Name",
    //     surname: "Small description about the project",
    // },
    // {   id:3,
    //     rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-8.png" , 
    //     className: "landing-page-project-card",
    //     text1: "Project Name",
    //     surname: "Small description about the project",
    // },
]

// export const Living = [
       
//     {   id:1,
//         rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-4.png" , 
//         className: "landing-page-project-card",
//         text1: "Project Name",
//         surname: "Small description about the project",
//     },
//     {   id:2,
//         rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-7.png" , 
//         className: "landing-page-project-card",
//         text1: "Project Name",
//         surname: "Small description about the project",
//     },
//     {   id:3,
//         rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-8.png" , 
//         className: "landing-page-project-card",
//         text1: "Project Name",
//         surname: "Small description about the project",
//     },
// ]
export const Interior = [
       
    {   id:5,
        rectangle62: "/Images/Home_Page/Img/Projects/Project_Interiors_Card.jpg" , 
        className: "landing-page-project-card",
        text1: "1BHK / 4BHK Triplex Residential – 30’x50’",
        surname: "Dr. Manjunath & Dr. Gayathri P – Ullal, Bangalore",
    },
    // {   id:2,
    //     rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-6.png" , 
    //     className: "landing-page-project-card",
    //     text1: "Project Name",
    //     surname: "Small description about the project",
    // },
    // {   id:3,
    //     rectangle62: "/Images/Home_Page/Img/Projects/Homepage-Card-9.png" , 
    //     className: "landing-page-project-card desktop-only",
    //     text1: "Project Name",
    //     surname: "Small description about the project",
    // },
]


export const PortfolioDetails = [
    {
        linkId:"mr-shrinivas",
        projectName: "1BHK / 2BHK Duplex Residential - 30’x 45",
        bannerImage: "/Images/Portfolio_Detail/Project_HRBR_Banner.jpg",
        name: "Mr. Srinivas (Employee at Moody’s)",
        location:"HRBR, Bangalore",
        projectType:"Residential",
        siteDimentions:"30’x 45’",
        projectDirection:"North East Facing",
        noOfFloors:"4",
        details:"GF: 1BHK+Carparking. FF, SF: Duplex 2BHK/Floor, FF: 1BHK",
        builtUpArea:"4000 sft",
        services:"Architecture Planning, Construction, Interiors",
        projectvalue:"80 lakhs",
        projectstatus:"Completed",
        PortfolioDetailCard :[
        "/Images/Portfolio_Detail/srinivas/frount-side.jpg" ,
        "/Images/Portfolio_Detail/srinivas/right-side.jpg" , 
        "/Images/Portfolio_Detail/srinivas/interior.JPG" , 
        "/Images/Portfolio_Detail/srinivas/door.JPG" , 
        "/Images/Portfolio_Detail/srinivas/DSC02996.jpg" , 
        ],
        projectName22: "Previous",
        projectName32: "Next",
        button: "VIEW MORE",
    },
    {
        linkId:"mr-manjunath",
        projectName: "1BHK / 4BHK Triplex Residential – 30’ x 50’",
        bannerImage: "/Images/Portfolio_Detail/Project_Manju_Banner.jpg",
        name: "Dr. Manjunath & Dr. Gayathri P (Ophthalmologists, Vasan Eye Care)",
        location:"Ullal, Jnanajyothi Nagar, Railway Layout, Bangalore",
        projectType:"Residential",
        siteDimentions:"30’x 50’",
        projectDirection:"East Facing",
        noOfFloors:"4",
        details:"GF: 1BHK+Carparking. FF, SF & TF: 4BHK Triplex",
        builtUpArea:"4800 sft",
        services:"Architecture Planning, Construction, Interiors",
        projectvalue:"110 lakhs",
        projectstatus:"Completed",
        PortfolioDetailCard : [
        "/Images/Portfolio_Detail/manjunath/front.jpg" ,
        "/Images/Portfolio_Detail/manjunath/coridor.jpg" , 
        "/Images/Portfolio_Detail/manjunath/hall.jpg" , 
        "/Images/Portfolio_Detail/manjunath/Pooja-room.jpg" , 
        "/Images/Portfolio_Detail/manjunath/stair-case.jpg" , 
        "/Images/Portfolio_Detail/manjunath/balcany.jpg" ,
        ],
        projectName22: "Previous",
        projectName32: "Next",
        button: "VIEW MORE",
    },
    {
        linkId:"mr-vijay",
        projectName: "1BHK / 3BHK Duplex Residential - 33’x 24’",
        bannerImage: "/Images/Portfolio_Detail/Project_Vijay_Banner.jpg",
        name: "Mr. Vijay Venketeshwaran",
        location:"Potti Gardens, Jalahalli, Bangalore",
        projectType:"Residential",
        siteDimentions:"33’x 24’",
        projectDirection:"South East Facing",
        noOfFloors:"3",
        details:"GF: 1BHK+Carparking. FF & SF: 3BHK Duplex",
        builtUpArea:"2500 sft",
        services:"Architecture Planning, Construction",
        projectvalue:"52 lakhs",
        projectstatus:"Completed",
        PortfolioDetailCard : [
        "/Images/Portfolio_Detail/vijay/front.jpg" ,
        ],
        projectName22: "Previous",
        projectName32: "Next",
        button: "VIEW MORE",
    },
    {
        linkId:"mr-Shomith",
        projectName: "4BHK Duplex Residential - 30’x 50’",
        bannerImage: "/Images/Portfolio_Detail/Project_Shomith_Banner.jpg",
        name: "Mr. Shomith",
        location:"Dodabelle, Kengeri(Blue Jay Properties), Bangalore",
        projectType:"Residential",
        siteDimentions:"30’x 50’",
        projectDirection:"East Facing",
        noOfFloors:"3",
        details:"GF: 1BHK + Carparking. FF, SF: Duplex 4BHK",
        builtUpArea:"4200 sft",
        services:"Architecture Planning, Construction",
        projectvalue:"82 lakhs",
        projectstatus:"On-going",
        PortfolioDetailCard : [
        "/Images/Portfolio_Detail/shomit/hall.jpg" , 
        "/Images/Portfolio_Detail/shomit/pup.jpg" , 
        "/Images/Portfolio_Detail/shomit/kitchen.jpg" , 
        "/Images/Portfolio_Detail/shomit/enterance.jpg" , 
        "/Images/Portfolio_Detail/shomit/front.jpg" ,
        "/Images/Portfolio_Detail/shomit/steps.jpg" ,
        ],
        projectName22: "Previous",
        projectName32: "Next",
        button: "VIEW MORE",
    },
    {
        linkId:"mr-manjunath",
        projectName: "1BHK / 4BHK Triplex Residential – 30’ x 50’",
        bannerImage: "/Images/Portfolio_Detail/Project_Interiors_Banner.jpg",
        name: "Dr. Manjunath & Dr. Gayathri P (Ophthalmologists, Vasan Eye Care)",
        location:"Ullal, Jnanajyothi Nagar, Railway Layout, Bangalore",
        projectType:"Residential",
        siteDimentions:"30’x 50’",
        projectDirection:"East Facing",
        noOfFloors:"4",
        details:"GF: 1BHK+Carparking. FF, SF & TF: 4BHK Triplex",
        builtUpArea:"4800 sft",
        services:"Architecture Planning, Construction, Interiors",
        projectvalue:"110 lakhs",
        projectstatus:"Completed",
        PortfolioDetailCard : [
        "/Images/Portfolio_Detail/interior/Hall.jpeg" ,
        "/Images/Portfolio_Detail/interior/Hall1.jpeg" ,
        "/Images/Portfolio_Detail/interior/Hall2.jpeg" , 
        "/Images/Portfolio_Detail/interior/kitchen.jpeg" , 
        "/Images/Portfolio_Detail/interior/Bedroom.jpeg" , 
        "/Images/Portfolio_Detail/interior/Bedroom1.jpeg" , 
        "/Images/Portfolio_Detail/interior/Dining.jpeg" , 
        "/Images/Portfolio_Detail/interior/Wardrobe.jpeg" ,
        ],
        projectName22: "Previous",
        projectName32: "Next",
        button: "VIEW MORE",
    },

]

export const PackageConstruction = [
    {
        id:"1",
        categoryId:"1",
        className:"lpd-package-card",
        option: "Basic",
        icon: "/Images/Home_Page/Img/Icons/Packages/Basic.svg" , 
        amount: "1600",
        area: "Rs/Sft",
        button: "VIEW DETAILS"
    },
    {
        id:"2",
        categoryId:"1",
        className:"lpd-group-11",
        option: "Standard",
        icon: "/Images/Home_Page/Img/Icons/Packages/Standard.svg" , 
        amount: "1700",
        area: "Rs/Sft",
        button: "VIEW DETAILS"
    },
    {
        id:"3",
        categoryId:"1",
        className:"lpd-group-11",
        option: "Premium",
        icon: "/Images/Home_Page/Img/Icons/Packages/Premium.svg" ,
        amount: "1950",
        area: "Rs/Sft",
        button: "VIEW DETAILS"
    },
    {
        id:"4",
        categoryId:"1",
        className:"lpd-group-11",
        option: "Luxury",
        icon: "/Images/Home_Page/Img/Icons/Packages/Luxury.svg" , 
        amount: "2500",
        area: "Rs/Sft",
        button: "VIEW DETAILS"
    },
]


export const PackageInterior = [
    {
        id:"1",
        categoryId:"2",
        className:"lpd-package-card",
        option: "Basic",
        icon: "/Images/Home_Page/Img/Icons/Packages/Basic.svg" , 
        amount: "Rs. 1,50,000",
        area: "Onwards",
        button: "VIEW DETAILS"
    },
    {
        id:"2",
        categoryId:"2",
        className:"lpd-group-11",
        option: "Standard",
        icon: "/Images/Home_Page/Img/Icons/Packages/Standard.svg" , 
        amount: "Rs. 2,25,000",
        area: "Onwards",
        button: "VIEW DETAILS"
    },
    {
        id:"3",
        categoryId:"2",
        className:"lpd-group-11",
        option: "Premium",
        icon: "/Images/Home_Page/Img/Icons/Packages/Premium.svg" ,
        amount: "Rs. 4,75,000",
        area: "Onwards",
        button: "VIEW DETAILS"
    },
    {
        id:"4",
        categoryId:"2",
        className:"lpd-group-11",
        option: "Luxury",
        icon: "/Images/Home_Page/Img/Icons/Packages/Luxury.svg" , 
        amount: "Rs. 6,75,000",
        area: "Onwards",
        button: "VIEW DETAILS"
    },
]

export const Testimonials = [
    {
        text278: "The whole team was very very supportive and I am really very happy. I am an extremely happy customer, Thank you Webuild !",
        ellipse1: "/Images/Home_Page/Img/Testimonial/Ellipse-1.png" , 
        name: "Robert Fox",
        text279: "Bangalore, India",
        className:"",
    },
    {
        text278: "The whole team was very very supportive and I am really very happy. I am an extremely happy customer, Thank you Webuild !",
        ellipse1: "/Images/Home_Page/Img/Testimonial/Ellipse-2.png" , 
        name: "Annette Black",
        text279: "Bangalore, India",
        className: "group-27-1",
    }
]

export const InSights = {
    InsightsHeader: "/Images/JPG/Webuildd-Insights-Header.jpg" , 
}
   

export const InSights_Detail = {
    BbmpPlan : "/Images/Insights_detail/BBMP-Plan.jpg" , 
    BBMP : "/Images/Insights_detail/BBMP.jpg" , 
}
       
    
    

export const portfolio = {
    PortfolioHeader: "/Images/JPG/Webuildd-Projects-Header.jpg" 
}

export const PortfolioCards = [
    {
        divClass:"flex-col",
        divData:[
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card.jpg" ,
                className:"",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-1.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-2.jpg" ,
                className: "project-card-2",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-3.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-4.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-5.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
        ]
    },
    {
        divClass:'flex-col-1',
        divData:[
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-6.jpg" ,
                className:"",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-7.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-8.jpg" ,
                className: "project-card-2",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-9.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-10.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-11.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
        ]
    },
    {
        divClass:"flex-col-1",
        divData:[
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-12.jpg" ,
                className:"",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-13.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-14.jpg" ,
                className: "project-card-2",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-15.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-16.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
            {
                rectangle62: "/Images/Portfolio/Gallery/Portfolio-Card-17.jpg" ,
                className: "project-card-1",
                group99Props:{
                    text1: "Project Name",
                    surname: "Small description about the project",
                }
            },
        ]
    },  
]
   
    
  
export const portfolio_detail = {
    PortfolioDetailHeader: "/Images/Portfolio_Detail/Portfolio-detail-Header.jpg" , 
    Grid:"/Images/Portfolio_Detail/Grid.svg" , 
    PortfolioDetailCard1: "/Images/Portfolio_Detail/Gallery/Portfolio-detail-Card-1.jpg" ,
    PortfolioDetailCard2: "/Images/Portfolio_Detail/Gallery/Portfolio-detail-Card-2.jpg" , 
    PortfolioDetailCard3: "/Images/Portfolio_Detail/Gallery/Portfolio-detail-Card-3.jpg" , 
    PortfolioDetailCard4:"/Images/Portfolio_Detail/Gallery/Portfolio-detail-Card-4.jpg" , 
    PortfolioDetailCard5: "/Images/Portfolio_Detail/Gallery/Portfolio-detail-Card-5.jpg" , 
    PortfolioDetailCard6:"/Images/Portfolio_Detail/Gallery/Portfolio-detail-Card-6.jpg" , 
}
   


export const Videos_main = {
    VideosHeader: "https://youtu.be/wKnS8VPxpHI" ,
    VideoHeaderImage:'./Images/JPG/Webuildd-Videos.jpg', 
    Play:"/Images/Videos/Play-Icon.svg" , 
}    

export const YoutubCards = [
    {
        text129: "Lorem Ipsum passages of Lorem Ipsum available",
        address: "1034 Views / 24 May 2021 / 45 Comments",
        className: "gallery-page-card-video",
        youtubeThumbnail: "/Images/Videos/Gallery/Videos-Card-1.jpg" ,     
        videourl: "https://youtu.be/wKnS8VPxpHI"
    },
    {
        text129: "Lorem Ipsum passages of Lorem Ipsum available",
        address: "1034 Views / 24 May 2021 / 45 Comments",
        className: "gallery-page-card-video",
        youtubeThumbnail: "/Images/Videos/Gallery/Videos-Card-2.jpg" ,     
        videourl: "https://youtu.be/wKnS8VPxpHI"
    },
    {
        text129: "Lorem Ipsum passages of Lorem Ipsum available",
        address: "1034 Views / 24 May 2021 / 45 Comments",
        className: "gallery-page-card-video",
        youtubeThumbnail: "/Images/Videos/Gallery/Videos-Card-3.jpg" ,     
        videourl: "https://youtu.be/wKnS8VPxpHI"
    },
    {
        text129: "Lorem Ipsum passages of Lorem Ipsum available",
        address: "1034 Views / 24 May 2021 / 45 Comments",
        className: "gallery-page-card-video",
        youtubeThumbnail: "/Images/Videos/Gallery/Videos-Card-4.jpg" ,     
        videourl: "https://youtu.be/wKnS8VPxpHI"
    },
    {
        text129: "Lorem Ipsum passages of Lorem Ipsum available",
        address: "1034 Views / 24 May 2021 / 45 Comments",
        className: "gallery-page-card-video",
        youtubeThumbnail: "/Images/Videos/Gallery/Videos-Card-5.jpg" ,     
        videourl: "https://youtu.be/wKnS8VPxpHI"
    },
    {
        text129: "Lorem Ipsum passages of Lorem Ipsum available",
        address: "1034 Views / 24 May 2021 / 45 Comments",
        className: "gallery-page-card-video",
        youtubeThumbnail: "/Images/Videos/Gallery/Videos-Card-6.jpg" ,     
        videourl: "https://youtu.be/wKnS8VPxpHI"
    },
    {
        text129: "Lorem Ipsum passages of Lorem Ipsum available",
        address: "1034 Views / 24 May 2021 / 45 Comments",
        className: "gallery-page-card-video",
        youtubeThumbnail: "/Images/Videos/Gallery/Videos-Card-7.jpg" ,     
        videourl: "https://youtu.be/wKnS8VPxpHI"
    },
    {
        text129: "Lorem Ipsum passages of Lorem Ipsum available",
        address: "1034 Views / 24 May 2021 / 45 Comments",
        className: "gallery-page-card-video",
        youtubeThumbnail: "/Images/Videos/Gallery/Videos-Card-8.jpg" ,     
        videourl: "https://youtu.be/wKnS8VPxpHI"
    },
    {
        text129: "Lorem Ipsum passages of Lorem Ipsum available",
        address: "1034 Views / 24 May 2021 / 45 Comments",
        className: "gallery-page-card-video desktop-only",
        youtubeThumbnail: "/Images/Videos/Gallery/Videos-Card-9.jpg" ,     
        videourl: "https://youtu.be/wKnS8VPxpHI"
    },
] 



export const BrandLogos = [
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-ACC.png" ,
        className : "lpd-image-2",
        alt : "Webuildd ACC" 
    },
    {
        Brandlogo : "/Images/Home_Page/Img/Grey-BG/Webuildd-Anchor.png" ,
        className : "lpd-image",
        alt : "Webuildd Anchor" 
    },
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-CERA.png" , 
        className : "lpd-image-4",
        alt : "Webuildd CERA" 
    },
    {
        Brandlogo : "/Images/Home_Page/Img/Grey-BG/Webuildd-GM.png" , 
        className : "lpd-image",
        alt : "Webuildd Gm" 
    },
    {
        Brandlogo : "/Images/Home_Page/Img/Grey-BG/Webuildd-Greenply.png" , 
        className : "lpd-image-6",
        alt : "Webuildd Greenply" 
    },
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-JSW.png" ,
        className : "lpd-image",
        alt : "Webuildd JSW" 
    },
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-Hettich.png" ,
        className : "lpd-image-2",
        alt : "Webuildd Hettich" 
    },
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-Jaguar.png" ,
        className : "lpd-image",
        alt : "Webuildd Jaguar" 
    },
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-Kajaria.png" ,
        className : "lpd-image-4",
        alt : "Webuildd Kajaria" 
    },
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-Legrand.png" ,
        className : "lpd-image",
        alt : "Webuildd Legrand" 
    },
    {
        Brandlogo:  "/Images/Home_Page/Img/Grey-BG/Webuildd-Meenakshi.png" ,
        className : "lpd-image-6",
        alt : "Webuildd Meenakshi" 
    },
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-RAMCO.png" ,
        className : "lpd-image",
        alt : "Webuildd RAMCO" 
    },
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-Saint-Gobain.png" ,
        className : "lpd-image-2",
        alt : "Webuildd Saint Gobain" 
    },
    {
        Brandlogo :  "/Images/Home_Page/Img/Grey-BG/Webuildd-Turbo-Steel.png" ,
        className : "lpd-image",
        alt : "Webuildd Turbo Steel" 
    },
    {
        Brandlogo:  "/Images/Home_Page/Img/Grey-BG/Webuildd-Ultratech.png" ,
        className : "lpd-image-4",
        alt : "Webuildd Ultratech" 
    },
]





// About Us Text started here

export  const About_Us_Text ={
    Experience_Text_Head:"Experience",
    Experience_Text:"With over 40 years in the construction field, spanning over 3 generations, we have been at the forefront of every crucial change seen in the construction industry. This vast experience and keen foresight into the future allow us to meet the needs of today and consider the demands of your future needs.",
    
    Warranty_Text_Head:"Warranty",
    Warranty_Text:"We will give a structural warranty of up to 50 years and a 1-year Defect Liability and Seepage free warranty.",
    
    Completion_Text_Head:"On-Time Completion",
    Completion_Text:<>We commit ourselves to complete our projects at the agreed-upon timeline. We provide a detailed timeline of project phases and milestones ahead of time, which we follow using our tried-and-true standard operating procedures. <br/> It ensures that we achieve every milestone at the time that we have committed.</>,
    
    SOPC_Text_Head:"Single-Point-Contact",
    SOPC_Text:<>We are here to make your home buying journey easy. We provide a systematic approach with a single-point contact that takes information from 9 cross-functional teams to put your mind at rest regarding each stage of your home construction process.  <br/><br/> Start your journey with us - use our online construction calculator now.</>,
}
